import { inject, observer } from 'mobx-react'
import * as R from 'ramda'
import React from 'react'

import Button from 'components/styleguide/Button'
import { IStoreProvider } from 'store'
import { ProductStreamStore } from 'types/productStreamStore'

import styled from 'styled-components'
import * as styles from './styles.module.scss'

interface Props {
  categoryId: any
  texts: {
    [key: string]: string
  }
  productStreamStore: ProductStreamStore
  clearFilter(): void
}

const StyledButton = styled(Button)`
  display: block;
  line-height: 38px;
  margin: 0 auto;
  width: auto;
`

const NoFilterResults = (props: Props): JSX.Element => {
  const { texts } = props

  return (
    <div className={styles.noFilterResults}>
      <strong className={styles.title}>{texts.headline}</strong>
      <p className={styles.text}>{texts.copy}</p>
      <StyledButton onClick={props.clearFilter}>{texts.reset}</StyledButton>
    </div>
  )
}

export default R.compose(
  inject((stores: IStoreProvider, { productStreamStore }: Props) => {
    return {
      texts: {
        reset: stores.t('Alle Filter löschen'),
        headline: stores.t('Leider nichts gefunden ...'),
        copy: stores.t(
          'Bearbeite Deine Filter, um passende Suchergebnisse zu sehen.',
        ),
      },
      appliedFilters: productStreamStore.filter.selectedLooseFilters,
    }
  }),
  observer,
)(NoFilterResults)
